import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router';
import { useMaxViewport } from '../../core/hooks/use-max-viewport';
import { Icon } from '../icon/icon';
import { IconVariant } from '../icon/icon-data';
import { Typography } from '../typography/typography';
import { notNil } from '../../core/helpers/is-nil';
import { Badge } from '../badge/badge';
import styles from './app-header-button.module.scss';

type LocaleVariant = {
  type: 'locale';
  text: string;
};

export type LinkIconVariant = {
  type: 'linkIcon';
  icon: IconVariant;
  label: string;
  link: React.ComponentProps<typeof Link>;
  badge?: React.ReactElement<typeof Badge>;
};

type Props = {
  variant: LocaleVariant | LinkIconVariant;
  active?: boolean;
};

export const AppHeaderButton: React.FC<Props> = ({ variant, active, ...rest }) => {
  const isTablet = useMaxViewport('s');

  if (variant.type === 'locale') {
    return (
      <button
        className={classNames(styles.triggerButton, {
          [styles.active]: active,
        })}
        {...rest}
      >
        <Typography tag="span" variant="buttontext">
          {variant.text}
        </Typography>
      </button>
    );
  }

  if (variant.type === 'linkIcon') {
    return (
      <Link
        aria-label={variant.label}
        to={variant.link.to}
        className={classNames(styles.triggerButton, {
          [styles.active]: active,
        })}
      >
        <Icon size={isTablet ? '24' : '32'} variant={variant.icon} />
        {notNil(variant.badge) ? <div className={styles.badgeContainer}>{variant.badge}</div> : null}
      </Link>
    );
  }
};
